import InlineTextInput from '@/components/ui/inline-text-input';
import { pdkAxios } from '@/lib/pdk-axios';
import type { Trade } from '@/models/registry';
import { tradesStore } from '@/stores/trades-store';
import { useMutation } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

const TradeVehicleLienholderEditor = ({
  tradeId,
  initialLienholder,
}: {
  tradeId: Trade['id'];
  initialLienholder: string;
}) => {
  const [lienholder, setLienholder] = useState(initialLienholder);

  const updateLienholderMutation = useMutation({
    onMutate: async ({ lienholder }: { lienholder: string }) => {
      tradesStore.updateTrade(tradeId, {
        lienholder: lienholder,
      });
    },
    mutationFn: async ({ lienholder }: { lienholder: string }) => {
      const response = await pdkAxios.post(
        `/trades/${tradeId}/lienholder`,
        // /api/trades/:trade_id/lienholder
        {
          lienholder,
        },
      );

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error updating lienholder', error, variables);
      // TODO: handle error by adding the original cdkId back to the store
    },
  });

  const handleLienholderChange = useCallback(
    debounce((newLienholder: string) => {
      updateLienholderMutation.mutate({ lienholder: newLienholder });
    }, 1000),
    [],
  );

  useEffect(() => {
    if (lienholder === initialLienholder) return;

    handleLienholderChange(lienholder);
  }, [lienholder]);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setLienholder(e.target.value);
  }, []);

  useEffect(() => {
    setLienholder(initialLienholder);
  }, [initialLienholder]);

  return (
    <div className="flex flex-row gap-1 items-center justify-between">
      <div className="flex flex-row gap-1 items-center">
        <div className="text-sm text-gray-500 dark:text-white">Lienholder</div>
      </div>
      <InlineTextInput
        value={lienholder}
        onChange={onChange}
        placeholder="Enter lienholder"
        className="text-right"
        wrapperClassName="gap-1"
      />
    </div>
  );
};

export default TradeVehicleLienholderEditor;
